import { render, staticRenderFns } from "./DocumentTreeRead.vue?vue&type=template&id=0048a51a&scoped=true&"
import script from "./DocumentTreeRead.vue?vue&type=script&lang=ts&"
export * from "./DocumentTreeRead.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentTreeRead.vue?vue&type=style&index=0&id=0048a51a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0048a51a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTreeview})
